var DrawablePageNoteView = require('../drawableNote');


module.exports = DrawablePageNoteView.extend({


    serializeData: function() {

        var context =
            DrawablePageNoteView.prototype.serializeData.apply( this, arguments );

        context.allowModifyOrDelete =
            context.viewerChannel.request('allowModifyOrDeleteHighlight');

        return context;

    },


    templateHelpers: _.extend( {}, DrawablePageNoteView.prototype.templateHelpers, {

        includeEditBtn: function() {

           return this.allowModifyOrDelete;

        },

        includeDeleteBtn: function() {

            return this.allowModifyOrDelete;

        }

    })

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/highlight/view.js
 ** module id = 289
 ** module chunks = 0
 **/